import axios from 'axios'

const BASE_URL = process.env.VUE_APP_API_URL

axios.defaults.baseURL = BASE_URL
axios.defaults.headers.common['Content-Type'] = 'application/json'

const axiosInstance = axios.create({
  // validateStatus: () => true // 모든 상태코드를 resolve 처리
})

const ApiService = {
  get: (resource: any, query: any) => {
    return axiosInstance.get(`${resource}/${query}`)
  },
  post: (resource: any, params: any) => {
    return axiosInstance.post(`${resource}`, params)
  },
  uploadImage: (resource: any, formData: FormData) => {
    return axiosInstance.post(`${resource}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}

export const API_URL = {
  CHECK_BOOTH_ID: '/getboothtmlid',
  GET_COUNTRY_CODE: '/getcountrycode',
  PASSPORT_OCR: '/passportocr',
  GET_UNBOOKED_REFUNDS: '/getunbookedrefundsliplist',
  GET_UNEXPORTED_REFUNDS: '/getunexportedrefundsliplist',
  RECEIPT_MAPPING: '/checkrefundslip',
  GET_REFUND_HISTORY: '/getrefundsliplist',
  VALID_CARD_NO: '/validcardno',
  SEARCH_ALIPAY_ID: '/searchalipayid',
  BOOK_REFUNDS: '/remitreserve',
  OUT_REQUEST: '/outrequest'
}

export default ApiService
